export default {
  name: 'MaterialSymbolsCancel'
};